// extracted by mini-css-extract-plugin
var _1 = "sDYtf";
export { _1 as "loading" }
